import { render, staticRenderFns } from "./LookTeacherProfile.vue?vue&type=template&id=09300999"
import script from "../../services/student/look-teacher-profile.js?vue&type=script&lang=js&external"
export * from "../../services/student/look-teacher-profile.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports